import { useEffect } from '@wordpress/element';
import { addFilter, removeFilter } from '@wordpress/hooks';

/**
 * Custom hook to ensure a filter will be applied dynamically in the editor.
 *
 * @param {string}   hookName     The hook name to add the filter to
 * @param {string}   nameSpace    The namespace to use for the filter
 * @param {Function} callback     The callback function to execute when the filter is applied
 * @param {boolean}  shouldFilter Whether to add or remove the filter
 *
 * @return {void}
 */
const useFilter = (hookName, nameSpace, callback, shouldFilter = true) => {
  useEffect(() => {
    if (shouldFilter) {
      addFilter(hookName, nameSpace, callback);
    } else {
      removeFilter(hookName, nameSpace);
    }

    return () => {
      removeFilter(hookName, nameSpace);
    };
  }, [hookName, nameSpace, callback, shouldFilter]);
};

export default useFilter;
